var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	}

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;

			// Initialize scroll tracking variables
			this.lastScrollTop = 0;
			this.scrollDirection = 'none';
			this.$body.css('--current-scrolltop', `${window.scrollY}px`);

			this.scrollThreshold = 5; // Hysteresis threshold in pixels
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).on('resize', this.setVw);
		}

		scroll() {
			var scroll = window.scrollY;

			// Add scroll position as CSS variables
			this.$body.css('--current-scrolltop', `${scroll}px`);

			// Add clamped percentage (max 100%)
			const headerHeight = document.headerHeightScrolled || 100;
			const scrollPercentage = Math.min(100, (scroll / headerHeight) * 100);
			this.$body.css('--scroll-percentage', `${scrollPercentage}%`);

			// Detect scroll direction with hysteresis
			if (Math.abs(scroll - this.lastScrollTop) > this.scrollThreshold) {
				if (scroll > this.lastScrollTop) {
					// Scrolling down - only add class if past header height
					if (this.scrollDirection !== 'down' && scroll >= document.headerHeightScrolled) {
						this.$body.removeClass('is-scrolling-up').addClass('is-scrolling-down');
						this.scrollDirection = 'down';
					} else if (this.scrollDirection === 'up') {
						// If we were scrolling up but now going down, just remove up class
						this.$body.removeClass('is-scrolling-up');
						this.scrollDirection = 'none';
					}
				} else {
					// Scrolling up - always add class regardless of position
					if (this.scrollDirection !== 'up') {
						this.$body.removeClass('is-scrolling-down').addClass('is-scrolling-up');
						this.scrollDirection = 'up';
					}
				}
				this.lastScrollTop = scroll;
			}

			// Handle scrolled state
			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				this.$body.removeClass('is-scrolling-up is-scrolling-down');
				this.scrollDirection = 'none';
				return;
			}
		}

		setVw() {
			let vw = document.documentElement.clientWidth / 100;
			document.documentElement.style.setProperty('--vw', `${vw}px`);
		}
	}

})(jQuery);

export default documentInit;